import { render } from "./unauthenticated.vue?vue&type=template&id=52b545fe"
import script from "./unauthenticated.vue?vue&type=script&lang=js"
export * from "./unauthenticated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/pqv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/layouts/unauthenticated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52b545fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52b545fe', __exports__)) {
    console.log('reload')
    api.reload('52b545fe', __exports__)
  }
  
  module.hot.accept("./unauthenticated.vue?vue&type=template&id=52b545fe", () => {
    console.log('re-render')
    api.rerender('52b545fe', render)
  })

}


export default __exports__